import React from "react";
import styled from "styled-components";
import { useTheme } from "@mui/material/styles";

// Styled Components
const StepWrapper = styled.div`
  max-width: 100%;
  width: auto;
  height: auto;
  background: ${props => props.theme?.palette?.primary?.main || '#FF8533'};
  border: 2px solid rgba(255, 255, 255, 0.5);
  box-sizing: border-box;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.25);
  backdrop-filter: blur(20px);
  border-radius: 80px;
  align-items: center;
  justify-items: center;
  text-align: center;
  padding: 30px 50px;
  transition: all 0.3s ease-out;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  animation: fadeInUp 0.8s ease-out;

  @keyframes fadeInUp {
    from {
      opacity: 0;
      transform: translateY(30px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  &:hover {
    border: 3px solid rgba(255, 255, 255, 0.5);
    box-shadow: 20px 10px 50px rgba(0, 75, 117, 0.3);
    backdrop-filter: blur(20px);
    transform: translateY(-5px);
  }

  @media (max-width: 1200px) {
    padding: 25px 40px;
    border-radius: 60px;
  }

  @media (max-width: 1024px) {
    padding: 20px 30px;
    border-radius: 50px;
  }

  @media (max-width: 768px) {
    padding: 15px 20px;
    border-radius: 40px;
  }

  @media (max-width: 480px) {
    padding: 12px 15px;
    border-radius: 30px;;
  }

  @media (max-width: 360px) {
    padding: 10px 12px;
    border-radius: 25px;
  }
`;

const ImageWrapper = styled.div`
  margin: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;
  transition: all 0.3s ease-out;
  min-height: 200px;
  width: 100%;
  padding: 20px;

  @media (max-width: 1200px) {
    min-height: 180px;
    padding: 15px;
  }

  @media (max-width: 768px) {
    min-height: 160px;
    padding: 10px;
  }

  @media (max-width: 480px) {
    min-height: 140px;
    padding: 8px;
  }

  @media (max-width: 360px) {
    min-height: 120px;
    padding: 6px;
  }
`;

const StepImage = styled.img`
  max-width: 100%;
  max-height: 100%;
  width: auto;
  height: auto;
  object-fit: contain;
  transition: all 0.3s ease-out;
  display: block;

  &:hover {
    transform: scale(1.05);
  }

  @media (max-width: 1200px) {
    max-width: 90%;
    max-height: 90%;
  }

  @media (max-width: 1024px) {
    max-width: 85%;
    max-height: 85%;
  }

  @media (max-width: 768px) {
    max-width: 80%;
    max-height: 80%;
  }

  @media (max-width: 480px) {
    max-width: 75%;
    max-height: 75%;
  }

  @media (max-width: 360px) {
    max-width: 70%;
    max-height: 70%;
  }
`;

const StepButton = styled.button`
  color: ${props => props.theme?.palette?.secondary?.main || 'rgba(0, 143, 211, 1)'};
  background-color: white;
  font-size: 22px;
  font-weight: 600;
  border: none;
  border-radius: 30px;
  padding: 12px 24px;
  cursor: pointer;
  transition: all 0.3s ease-out;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.15);

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0px 8px 20px rgba(0, 0, 0, 0.25);
  }

  &:active {
    transform: translateY(-1px);
  }

  @media (max-width: 1200px) {
    font-size: 18px;
    padding: 10px 20px;
  }

  @media (max-width: 1024px) {
    font-size: 16px;
  }

  @media (max-width: 768px) {
    font-size: 14px;
  }
`;

const StepLink = styled.a`
  text-decoration: none;
  color: ${props => props.theme?.palette?.secondary?.main || 'rgba(0, 143, 211, 1)'};
  background-color: transparent;
  font-size: inherit;
  font-weight: inherit;
  transition: all 0.3s ease-out;

  &:hover {
    color: ${props => props.theme?.palette?.secondary?.dark || '#005a8b'};
  }
`;

function Steps(props) {
  const theme = useTheme();

  return (
    <StepWrapper theme={theme}>
      <ImageWrapper>
        <StepImage src={props.stepImage} alt="stepimg" />
      </ImageWrapper>
      <StepButton theme={theme}>
        <StepLink href={props.ButtonLink} theme={theme}>
          {props.Button}
        </StepLink>
      </StepButton>
    </StepWrapper>
  );
}

export default Steps;
